import React from 'react';

import useTranslation from 'src/hooks/use-translation';
import useProductQueryParams from 'src/hooks/use-product-query-params';
import Section from 'src/components/sidebar-filters/section';
import { CheckboxGroup } from 'src/components/core';

type CustomTagFilterProps = {
  tags: string[];
  title?: string;
};

export function CustomTagFilter({ tags, title }: CustomTagFilterProps): JSX.Element {
  const { t } = useTranslation();
  const { defaults, queryParams, setQueryParams } = useProductQueryParams();
  const currentTags = queryParams.tags;

  const tagOptions = tags.map((tag) => ({ key: tag, label: tag, value: tag }));

  const handleOptionClick = (tagValue: string): void => {
    const tagsSet = new Set(currentTags);

    if (tagsSet.has(tagValue)) {
      tagsSet.delete(tagValue);
    } else {
      tagsSet.add(tagValue);
    }

    setQueryParams({
      tags: Array.from(tagsSet),
      page: defaults.page,
    });
  };

  return (
    <Section startsOpen heading={title || t('common.tag_plural', 'Tags')}>
      <CheckboxGroup options={tagOptions} selectedOptions={currentTags} onSelect={handleOptionClick} />
    </Section>
  );
}
